import { fetchOnce } from "../../../common/utils/fetchOnce";
import { appUrls } from "../../../EasyProjectsCommon/AppUrls";
import { OAuthClient } from "../../../EasyProjectsCommon/OAuthClient";
import { AccountSettingsResponseModel } from "../reducers/accountSettings";

export const accountSettingsApi = {
    getAccountSettings: fetchOnce(() => {
        return OAuthClient.postJson(appUrls.usermanagement.users.getAccountSettings).then(resp => resp);
    }) as F<PromiseLike<AccountSettingsResponseModel>>,
};
